module.exports = __webpack_public_path__ + "static/media/HCMM072.d874ce33.jpg";